(() => {
 function setup(root) {
  if(root.dataset.productReady)return;
  root.dataset.productReady='true';
  const form=root.querySelector('[data-native-add]');
  if(!form)return; // Quote-only equipment has a contact action instead of a purchase form.
  const variant=form.querySelector('select[name=id]');
  // Custom build is a navigation action, not a manufacturer variant.
  // Keep this combined selector visible; the presentation client owns its actions.
  if(variant.dataset.buildUrl)return;
  const options=[...variant.options];
  const names=JSON.parse(variant.dataset.optionNames);
  const values=options.map(option=>JSON.parse(option.dataset.options));
  const field=root.querySelector('[data-combined-option]');
  const image=root.querySelector('[data-native-main-image]');
  const photos=[...root.querySelectorAll('[data-native-photo]')];
  const showPhoto=(src,alt)=>{
   if(!image)return;
   image.src=src;image.alt=alt;image.toggleAttribute('data-supplier-reference',src.includes('oh-xs-reference-'));
   photos.forEach(photo=>photo.toggleAttribute('aria-current',new URL(photo.href).pathname===new URL(src,location.href).pathname));
  };
  photos.forEach(photo=>photo.addEventListener('click',event=>{event.preventDefault();showPhoto(photo.href,photo.dataset.alt);}));
  const selectors=[];
  if(options.length>1) {
   names.forEach((name,index)=>{
    const label=document.createElement('label');label.textContent=name;
    const select=document.createElement('select');select.dataset.nativeOption=String(index);
    for(const value of new Set(values.map(row=>row[index])))select.add(new Option(value,value));
    select.value=values[variant.selectedIndex][index];label.append(select);field.before(label);selectors.push(select);
    select.addEventListener('change',()=>{
     // Keep earlier choices; only adjust later choices when a combination does not exist.
     const exact=values.findIndex(row=>row.every((value,n)=>value===selectors[n].value));
     const match=exact>=0?exact:values.findIndex(row=>row.every((value,n)=>n>index||value===selectors[n].value));
     if(match>=0){variant.selectedIndex=match;variant.dispatchEvent(new Event('change',{bubbles:true}));}
    });
   });
   field.hidden=true;
   form.querySelector('[data-native-options]').classList.toggle('oh-shop-options--single',names.length===1);
  } else {
   const text=document.createElement('span');text.className='oh-quick-option-value';text.textContent=options[0].textContent.split(' · ')[0];field.append(text);variant.hidden=true;
  }
  const refresh=()=>{
   const option=variant.selectedOptions[0];if(!option)return;
   const current=JSON.parse(option.dataset.options);
   selectors.forEach((select,index)=>{
    select.value=current[index];
    [...select.options].forEach(o=>{o.disabled=!values.some(row=>row[index]===o.value&&row.every((value,n)=>n>=index||value===current[n]));});
   });
   root.querySelector('[data-native-sku]').textContent=option.dataset.sku;
   if(option.dataset.image)showPhoto(option.dataset.image,option.dataset.alt);
   const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState(history.state,'',url);
  };
  variant.addEventListener('change',refresh);
  // Do not replace the initial gallery or address on page load.
 }
 document.querySelectorAll('[data-native-product]').forEach(setup);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-native-product]').forEach(setup));
})();
